import { useCallback } from 'react';

import { useAppDispatch } from 'src/application/hooks/useAppDispatch';

import { dismissScrollTour } from '../actions/guidedTourActions';
import { useStudentSelector } from '../store/selectors/useStudentSelector';

export const useScrollGuidedTour = () => {
  const isShowing = !useStudentSelector((state) => state.preferences.guidedTour.scrollDimissed);
  const dispatch = useAppDispatch();
  const dismiss = useCallback(() => dispatch(dismissScrollTour), [dispatch]);

  return { isShowing, dismiss };
};
